import { REQUEST } from '../../../utils/actionGenerator';
import { fork, take } from 'redux-saga/effects';
import * as api from '../../../utils/api';
import { fetchEntity } from '../../../store/saga';
import * as laneRateDashboard from './actions';

export function* getLaneRateList(params) {
  const request = api.getLaneRateListRequest.bind(null, params);
  yield fetchEntity(request, laneRateDashboard.getLaneRateList, null);
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* watchGetLaneRateListSaga() {
  while (true) {
    const { params } = yield take(laneRateDashboard.GET_LANE_RATE_LIST[REQUEST]);
    yield fork(getLaneRateList, params);
  }
}
